query GetCompanies(
  $page: Int
  $limit: Int
  $stringFilters: [CompanyStringFilterInput!]
  $sortBy: String
) {
  companies(
    page: $page
    limit: $limit
    stringFilters: $stringFilters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      salesforceId
      companyType {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
